"use client";
import { useEffect } from "react";

/**
 * Useful to prevent background scroll when overlayed with a full screen popover
 */
export function LockBodyScroll() {
  useEffect(() => {
    // document.body.style.position = "fixed";
    document.body.style.overflow = "hidden";
    return () => {
      // document.body.style.position = "static";
      document.body.style.overflow = "visible";
    };
  });
  return null;
}
